import Mountable from '../types/mountable';

import EventData from './event-data';

import { EventBus } from '.';

export type EventCallback = (...args: unknown[]) => void;

export interface EventMap {
  [key: string]: EventCallback;
}

/**
 * Basice EventDelegator responsible to fire events.
 */
class EventDelegator<T extends Mountable, ED extends EventData<T>> {

  eventBus: EventBus<ED>;
  events: EventMap;

  constructor() {
    this.events = {};
    this.eventBus = new EventBus();
  }

  /**
   * Fires the event.
   * @param type the event type.
   * @param event the event data.
   */
  fire(type: string, event: EventData<any>): void {
    const callback = this.events[type];
    callback && callback(event);
  }

}

export default EventDelegator;
